// Cuentas incobrables — moving a reservation's debt out of the day-to-day
// collections process so it can be pursued separately (extrajudicial, despacho,
// acuerdo aparte). The money is still owed and still on the books; what changes
// is who chases it and how.
//
// The mark lives on the reservation, not the client: a client can have one debt
// in separate handling while still running live leases whose rent must stay in
// normal collections. `written_off_at IS NOT NULL` is the flag.
//
// Effect: the debt leaves the Saldo a Hoy report and shows up in Cuentas
// Incobrables instead. Both directions need the `reservations.write_off`
// permission, and marking additionally requires the client to already be
// blocked — both enforced by the `enforce_write_off_authority` trigger.

import supabase from "../supabase-client";

export const WRITE_OFF_PERMISSION = "reservations.write_off";

const WRITE_OFF_COLUMNS = "written_off_at, written_off_by, written_off_notes";

// Reads just the write-off columns for one reservation. Returns null when
// there's nothing to look up.
export async function fetchWriteOff(reservationId) {
  if (!reservationId) return null;
  const { data, error } = await supabase
    .from("reservations")
    .select(WRITE_OFF_COLUMNS)
    .eq("id", reservationId)
    .maybeSingle();
  if (error) {
    console.error(error.message);
    return null;
  }
  return data || null;
}

export async function markWriteOff({ reservationId, notes, userId }) {
  if (!reservationId) return { error: "Reservación inválida" };
  const patch = {
    written_off_at: new Date().toISOString(),
    written_off_by: userId || null,
    written_off_notes: (notes || "").trim() || null,
  };
  const { error } = await supabase
    .from("reservations")
    .update(patch)
    .eq("id", reservationId);
  return error ? { error: error.message } : { data: patch };
}

export async function clearWriteOff(reservationId) {
  if (!reservationId) return { error: "Reservación inválida" };
  const patch = {
    written_off_at: null,
    written_off_by: null,
    written_off_notes: null,
  };
  const { error } = await supabase
    .from("reservations")
    .update(patch)
    .eq("id", reservationId);
  return error ? { error: error.message } : { data: patch };
}
